import { proxy } from 'valtio';
export const goodwayStore = proxy({
    ma960: 0,
    txf: 0,
    pageState: 'index',
});
